const backToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};


export default function initBackToTop() {
  const container = document.querySelector('.cp-back-to-top');
  if (container.length) return;

  const btn = container.querySelector('.js-back-to-top');
  btn.addEventListener('click', backToTop);
}
